import { connect } from 'react-redux'
import PupilInfoForm from './pupil-info-form'
import {
  getProfile,
  getPupilUpdatingStatus,
  getPupilPasscodeResettingStatus,
  getPupilRemovingFromGroupStatus,
  getPupilAddingToGroupStatus
} from '../../../../../../stores/profile/profile.selectors'
import {
  updatePupil,
  resetPasscode
} from '../../../../../../stores/profile/profile.actions'
import { withRouter } from 'react-router'
import { openAddToGroupDialog } from '../../../../../add-to-group/add-to-group.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { match, me }) => {
  const pupil = getProfile(state)
  const updatingStatus = getPupilUpdatingStatus(state, match.params.id)
  const removingFromFormStatus = getPupilRemovingFromGroupStatus(
    state,
    match.params.id
  )
  const resettingPasscodeStatus = getPupilPasscodeResettingStatus(
    state,
    match.params.id
  )
  const addingToGroup = getPupilAddingToGroupStatus(state, match.params.id)
  return {
    editableProps: pupil.student_type.policy.editable_properties,
    editable: me.account.policy.can_manage_students,
    id: pupil.id,
    firstName: pupil.first_name,
    lastName: pupil.last_name,
    displayName: pupil.display_name,
    passCode: pupil.student_type.passcode,
    parentCode: pupil.student_type.parent_code,
    ageGroup: pupil.student_type.year_group && pupil.student_type.year_group.id,
    permission: pupil.student_type.policy.can_publish,
    showUpdatingOverlay:
      updatingStatus.pending ||
      resettingPasscodeStatus.pending ||
      removingFromFormStatus.pending ||
      addingToGroup.pending,
    parents: pupil.student_type.parent_types
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  updatePupil: data =>
    dispatch(
      updatePupil(stateProps.id, {
        first_name: data.firstName,
        last_name: data.lastName,
        display_name: data.displayName,
        year_group_id: data.ageGroup
      })
    ).catch(errorHandler),
  onResetPasscode: () =>
    dispatch(resetPasscode(stateProps.id)).catch(errorHandler),
  onAddToGroup: () => dispatch(openAddToGroupDialog([stateProps.id]))
})

export default withRouter(
  withMe(
    connect(
      mapStateToProps,
      mapDispatchToProps,
      mergeProps
    )(PupilInfoForm)
  )
)
